import React from "react";
import Modal from "./Modal";
const Servicos = () => {
  return (
    <section
      className="page-padding container mt-[20px] bg-[#FAFAFA]"
      id="servicos"
    >
      <div className="flex justify-center">
        <h1 className="text-slate-700 font-semibold text-3xl">Serviços</h1>
      </div>
      <div className=" grid grid-cols-1 gap-3 md:grid md:grid-cols-2 mt-3 lg:grid lg:grid-cols-3 xl:grid xl:grid-cols-4">
        <Modal
          title={"Formatação e atualização"}
          description={
            "Este serviço envolve a formatação do disco rígido do computador e a instalação de um sistema operacional atualizado. Isso pode incluir a instalação de drivers e atualizações de software, bem como a transferência de dados importantes para um backup antes da formatação."
          }
        />
        <Modal
          title={"Remoção de vírus e limpeza do sistema"}
          description={
            "Este serviço envolve a remoção de vírus, malware e outros programas indesejados que possam estar afetando o desempenho do computador. Também pode incluir a limpeza de arquivos temporários e a otimização do sistema operacional para melhorar o desempenho."
          }
        />
        <Modal
          title={"Solução para lentidão do sistema"}
          description={
            "Este serviço envolve a identificação e correção de problemas que possam estar causando lentidão no sistema. Isso pode incluir a limpeza do registro, a atualização de drivers e a desinstalação de programas desnecessários."
          }
        />
        <Modal
          title={"Instalação de programas"}
          description={
            "Este serviço envolve a instalação e configuração de programas específicos solicitados pelo cliente, como software de edição de vídeo, programas de design gráfico, softwares de produtividade e muito mais."
          }
        />
        <Modal
          title={"Configuração em geral"}
          description={
            " Este serviço envolve a configuração de diferentes aspectos do sistema, incluindo configurações de rede, configurações de impressora, configurações de segurança e muito mais."
          }
        />
        <Modal
          title={"Manutenção de Computadores"}
          description={
            "Este serviço envolve a manutenção preventiva do hardware do computador, incluindo limpeza interna, verificação de peças e componentes, diagnóstico de problemas de hardware e reparos necessários."
          }
        />
        <Modal
          title={"Manutenção de impressoras"}
          description={
            "Este serviço envolve a manutenção preventiva de impressoras, incluindo limpeza, verificação de conectividade, diagnóstico de problemas de hardware e reparos necessários."
          }
        />
        <Modal
          title={"Reparos em placas mãe de computadores"}
          description={
            "Este serviço envolve a identificação e reparo de problemas na placa-mãe do computador, incluindo substituição de componentes, reparo de circuitos e diagnóstico de problemas de hardware."
          }
        />
      </div>
    </section>
  );
};

export default Servicos;
